import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import FileField from "../forms/fields/FileField";
import OptionField from "../forms/fields/OptionField";
import MultipleOptionsField from "../forms/fields/MultipleOptionField";

export default class TaxDataForm extends SaporeForm {
    static newEmpty(feature = null, configuration) {
        const initialData = {
            afipRegistrationProof: null,
            grossIncomeTaxRegistrationProof: null,
            cm01form: null,
            cm05form: null,
            exemptionsCertificate: null,
            nonWithholdingCertificate: null,
            rawIncome: null,
            exemptionCertificateOption: null,
            provincesPerceptions: [],
            nonWithholdingCertificateOption: null,
            incomeTax: null,
            ivaCondition: null,
        };
        return new TaxDataForm(initialData, feature, configuration);
    }

    static newFor(initialData = null, feature = null, configuration) {
        return new TaxDataForm(initialData || {}, feature, configuration);
    }

    constructor(initialData = {}, feature = null, configuration) {
        const form = super({}, null, feature, configuration);

        const fields = {
            afipRegistrationProof: new FileField(0, 1, this.isOptional('afipRegistrationProof'), initialData.afipRegistrationProof, feature),
            grossIncomeTaxRegistrationProof: new FileField(0, 1, this.isOptional('grossIncomeTaxRegistrationProof'), initialData.grossIncomeTaxRegistrationProof, feature),
            cm01form: new FileField(0, 1, this.isOptional('cm01form'), initialData.cm01form, feature),
            cm05form: new FileField(0, 1, this.isOptional('cm05form'), initialData.cm05form, feature),
            exemptionsCertificate: new FileField(0, 1, this.isOptional('exemptionsCertificate'), initialData.exemptionsCertificate, feature),
            nonWithholdingCertificate: new FileField(0, 1, this.isOptional('nonWithholdingCertificate'), initialData.nonWithholdingCertificate, feature),
            rawIncome: new OptionField(feature.rawIncomeOptions(), this.isOptional('rawIncome'), feature, initialData.rawIncome),
            exemptionCertificateOption: new OptionField(feature.yesOrNoOptions(), this.isOptional('exemptionCertificateOption'), feature, initialData.exemptionCertificateOption),
            provincesPerceptions: new MultipleOptionsField(feature.provincesPerceptionsOptions(), this.isOptional('provincesPerceptions'), feature, initialData.provincesPerceptions),
            nonWithholdingCertificateOption: new OptionField(feature.yesOrNoOptions(), this.isOptional('nonWithholdingCertificateOption'), feature, initialData.nonWithholdingCertificateOption),
            incomeTax: new OptionField(feature.incomeTaxOptions(), this.isOptional('incomeTax'), feature, initialData.incomeTax),
            ivaCondition: new OptionField(feature.ivaConditionOptions(), this.isOptional('ivaCondition'), feature, initialData.ivaCondition),
        };

        form.setFields(fields);

        makeObservable(this, {
            afipRegistrationProofValue: computed,
            grossIncomeTaxRegistrationProofValue: computed,
            cm01formValue: computed,
            cm05formValue: computed,
            exemptionsCertificateValue: computed,
            nonWithholdingCertificateValue: computed,
            rawIncomeValue: computed,
            provincesPerceptionsValue: computed,
            exemptionCertificateOptionValue: computed,
            nonWithholdingCertificateOptionValue: computed,
            incomeTaxValue: computed,
            ivaConditionValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            rawIncome: '_raw_income',
            exemptionCertificateOption: '_exemption_certificate_option',
            provincesPerceptions: '_provinces_perceptions',
            nonWithholdingCertificateOption: '_non_withholding_certificate_option',
            nonWithholdingCertificate: '_non_withholding_certificate',
            incomeTax: '_income_tax',
            ivaCondition: '_iva_condition',
            afipRegistrationProof: '_afip_registration_proof',
            grossIncomeTaxRegistrationProof: '_gross_income_tax_registration_proof',
            cm01form: '_cm01_form',
            cm05form: '_cm05_form',
            exemptionsCertificate: '_exemptions_certificate',
        }
    }

    formEntity() {
        return this.values
    }

    afipRegistrationProof() {
        return this.getFieldByName('afipRegistrationProof').value;
    }

    grossIncomeTaxRegistrationProof() {
        return this.getFieldByName('grossIncomeTaxRegistrationProof').value;
    }

    cm01form() {
        return this.getFieldByName('cm01form').value;
    }

    cm05form() {
        return this.getFieldByName('cm05form').value;
    }

    nonWithholdingCertificate() {
        return this.getFieldByName('nonWithholdingCertificate').value;
    }

    exemptionsCertificate() {
        return this.getFieldByName('exemptionsCertificate').value;
    }

    rawIncome() {
        return this.getFieldByName('rawIncome').value;
    }

    incomeTax() {
        return this.getFieldByName('incomeTax').value;
    }

    ivaCondition() {
        return this.getFieldByName('ivaCondition').value;
    }

    nonWithholdingCertificateOption() {
        return this.getFieldByName('nonWithholdingCertificateOption').value;
    }

    provincesPerceptions() {
        return this.getFieldByName('provincesPerceptions').value;
    }

    exemptionCertificateOption() {
        return this.getFieldByName('exemptionCertificateOption').value;
    }

    get afipRegistrationProofValue() {
        return this.afipRegistrationProof()
    }

    get grossIncomeTaxRegistrationProofValue() {
        return this.grossIncomeTaxRegistrationProof()
    }

    get cm01formValue() {
        return this.cm01form()
    }

    get cm05formValue() {
        return this.cm05form()
    }

    get nonWithholdingCertificateValue() {
        return this.nonWithholdingCertificate()
    }

    get exemptionsCertificateValue() {
        return this.exemptionsCertificate()
    }

    get rawIncomeValue() {
        return this.rawIncome()
    }

    get exemptionCertificateOptionValue() {
        return this.exemptionCertificateOption()
    }

    get provincesPerceptionsValue() {
        return this.provincesPerceptions()
    }

    get nonWithholdingCertificateOptionValue() {
        return this.nonWithholdingCertificateOption()
    }

    get incomeTaxValue() {
        return this.incomeTax()
    }

    get ivaConditionValue() {
        return this.ivaCondition()
    }

}
